import { useQuery } from '@tanstack/react-query'

import { TCampaign } from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

const getCampaignById = (id: string) => {
  return HttpService.get<TCampaign>(
    {
      path: pathBuilder(EServerPath.campaign, { id }),
    },
    EHttpService.campaigns,
  )
}

const useGetCampaignById = (id: string, refetchInterval?: number) => {
  return useQuery({
    queryKey: queryKeys.campaign(id),
    queryFn: () => getCampaignById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchInterval: refetchInterval || 0,
  })
}

export default useGetCampaignById
